/*
SaiKrishna 10/06/2022 2700753823 Removed unnecessary console.log statements
 Sai Maheshwar 11/11/2022 3031689933  integrated locked process
*/
import axios from 'axios';

const defaultHeaders = {
  Accept: 'application/json',
};

function buildHeaders() {
  const authToken = sessionStorage.getItem('token');
  if (authToken && authToken !== 'undefined') {
    const batchName = sessionStorage.getItem('batchName');
    const xapikey = sessionStorage.getItem('xapikey');
    // const portalID = sessionStorage.getItem('PortalId');
    // const clientsID = sessionStorage.getItem('ClientsID');
    
    console.log("")
    const headers = {
      ...defaultHeaders, // Spread the default headers first
      Authorization: authToken,
      'x-api-key': xapikey,
      // 'X-Tenant-ID': 'rev1',
      // 'X-Clients-ID': '1sk3lla8ni410sumsrchl97g1l',
    };

    // Conditionally add the batchName if it exists
    return batchName ? { ...headers, batchName: batchName } : headers;
  }

  // If there's no valid authToken, return the default headers as is
  return { ...defaultHeaders };
}

function buildPythonHeaders() {
  if (sessionStorage.getItem('token') && sessionStorage.getItem('token') !== 'undefined') {
    const authToken = sessionStorage.getItem('token');
    const userid = sessionStorage.getItem('userId');
    return { ...defaultHeaders, userId: userid, token: authToken };
  }
  return { ...defaultHeaders };
}

// status check methods
export const checkData = (response) => {
  if (response.data && response.data.status >= 200 && response.data && response.data.status < 400) {
    return response.data;
  }
  return response;
};

// Release locked account process while logout
export const releaseLockedProcess = () => {
  httpGet('accountlock/release/lock');
};
// REST API methods with token
export const checkError = (error) => {
  if (error && error.response && [401, 403].includes(error.response.status)) {
    // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
    releaseLockedProcess();
    window.sessionStorage.clear();
    window.location.reload();
  }
  return error.response;
};

export const httpGet = (url) => {
  return axios(`${process.env.REACT_APP_API_END_POINT}/api/v1/` + url, {
    method: 'GET',
    headers: buildHeaders(),
  })
    .then(checkData)
    .catch(checkError);
};

export const httpPost = (url, body) => {
  return axios
    .post(`${process.env.REACT_APP_API_END_POINT}/api/v1/` + url, body, {
      headers: buildHeaders(),
    })
    .then(checkData)
    .catch(checkError);
};

export const httpPostCore = (url, body) => {
  return axios
    .post(`${process.env.REACT_APP_API_END_POINT}/core/` + url, body, {
      headers: buildHeaders(),
    })
    .then(checkData)
    .catch(checkError);
};

export const httpPutCore = (url, body) => {
  return axios
    .put(`${process.env.REACT_APP_API_END_POINT}/core/` + url, body, {
      headers: buildHeaders(),
    })
    .then(checkData)
    .catch(checkError);
};

export const httpPut = (url, body) => {
  return axios
    .put(`${process.env.REACT_APP_API_END_POINT}/api/v1/` + url, body, {
      headers: buildHeaders(),
    })
    .then(checkData)
    .catch(checkError);
};

export const httpDelete = (url) => {
  return axios
    .delete(`${process.env.REACT_APP_API_END_POINT}/api/v1/` + url, {
      headers: buildHeaders(),
    })
    .then(checkData)
    .catch(checkError);
};

export const httpPaginationPost = (url, body) => {
  return axios
    .post(`${process.env.REACT_APP_API_END_POINT}/api/v1/` + url, body, {
      headers: buildHeaders(),
    })
    .then((response) => response)
    .catch(checkError);
};

export const httpPaginationDelete = (url) => {
  return axios
    .delete(`${process.env.REACT_APP_API_END_POINT}/api/v1/` + url, {
      headers: buildHeaders(),
    })
    .then(checkData)
    .catch(checkError);
};
export const httpPaginationGet = (url) => {
  return axios
    .get(`${process.env.REACT_APP_API_END_POINT}/api/v1/` + url, {
      headers: buildHeaders(),
    })
    .then(checkData)
    .catch(checkError);
};
// rate-table

export const httpPythonGet = (url) => {
  return axios(`${process.env.REACT_APP_API_PYTHON_END_POINT}/api/v1` + url, {
    method: 'GET',
    headers: buildPythonHeaders(),
  })
    .then(checkData)
    .catch(checkError);
};

export const httpPythonPost = (url, body = {}) => {
  return axios
    .post(`${process.env.REACT_APP_API_PYTHON_END_POINT}/api/v1` + url, body, {
      headers: buildPythonHeaders(),
    })
    .then(checkData)
    .catch(checkError);
};

export const httpPythonPut = (url, body) => {
  return axios
    .put(`${process.env.REACT_APP_API_PYTHON_END_POINT}/api/v1` + url, body, {
      headers: buildPythonHeaders(),
    })
    .then(checkData)
    .catch(checkError);
};
